import { handleKeyDownInput } from '#pplx/frontend/composer-sdk/keyboard.js';
import { COMMAND_PRIORITY_NORMAL, KEY_ENTER_COMMAND } from 'lexical';
/**
 * Registers a KEY_ENTER_COMMAND handler that intercepts Enter so the input
 * submits (via the shared key-down handler) instead of inserting a newline,
 * while deferring to the mentions plugin when its menu can consume the key.
 *
 * @returns A cleanup function that unregisters the command (the disposer
 *   returned by `editor.registerCommand`); call it on teardown/unmount.
 */
export function enterCommand(editor, { mentionsPluginRef, enterKeyBehavior, isComposingRef, onKeyDownRef }) {
    return editor.registerCommand(KEY_ENTER_COMMAND, (event) => {
        if (!event)
            return false;
        if (mentionsPluginRef.current && !mentionsPluginRef.current.canSubmit()) {
            return false;
        }
        handleKeyDownInput(event, {
            enterKeyBehavior,
            isComposing: isComposingRef.current,
            onKeyDown: onKeyDownRef.current,
        });
        // If the event is defaultPrevented, we return true to stop Lexical
        // from handling the event--adding a new paragraph on enter.
        return event.defaultPrevented;
    }, COMMAND_PRIORITY_NORMAL);
}
//# sourceMappingURL=enterCommand.js.map